import type * as React from 'react'
import { isLightColor } from '../../helpers/colors'

interface SwatchCssProperties extends React.CSSProperties {
  '--swatch-background-color': string
  '--swatch-text-color': string
}

export const generateSwatchCssProperties = (
  color: string,
): SwatchCssProperties => {
  return {
    '--swatch-background-color': color,
    '--swatch-text-color': isLightColor(color)
      ? `color-mix(in srgb, ${color} 10%, black)`
      : `color-mix(in srgb, ${color} 10%, white)`,
  }
}
